import { StepLabel as MUIStepLabel, styled } from '@mui/material'
import useGetStepLabelTemplate from '~/src/components/mui-wrappers/styled/step-label/styles/useGetStepLabelTemplate'

const StepLabel = styled(MUIStepLabel)(() => useGetStepLabelTemplate().getComponentSx())

export default StepLabel
